/**
 * Stops the Enter key from implicitly submitting the long lead-capture forms
 * (Contact, Request a Quote, Employment Application, Service & Warranty), where
 * a stray keypress mid-typing would fire off an incomplete submission.
 *
 * Opt in per form by adding data-sg-no-enter-submit to any wrapper around it.
 * Short functional forms (search, login, newsletter, cart) are untouched.
 */
(function () {
  'use strict';

  const GUARD_ATTRIBUTE = 'data-sg-no-enter-submit';

  // Enter is a deliberate activation on these, not an accidental submit, so it
  // must keep working: buttons, links, native selects, and the custom
  // dropdowns/comboboxes inside the Shopify Forms embeds.
  const PASSTHROUGH_TAGS = new Set(['TEXTAREA', 'BUTTON', 'A', 'SELECT', 'SUMMARY', 'OPTION']);
  const PASSTHROUGH_ROLES = new Set([
    'button',
    'combobox',
    'listbox',
    'option',
    'menu',
    'menuitem',
    'menuitemcheckbox',
    'menuitemradio',
    'tab',
    'link',
  ]);
  const PASSTHROUGH_INPUT_TYPES = new Set(['submit', 'button', 'image', 'reset']);

  function isPassthrough(el) {
    if (!el || el.nodeType !== 1) return true;
    if (PASSTHROUGH_TAGS.has(el.tagName)) return true;
    if (el.isContentEditable) return true;

    const role = (el.getAttribute && el.getAttribute('role')) || '';
    if (PASSTHROUGH_ROLES.has(role.toLowerCase())) return true;

    if (el.tagName === 'INPUT' && PASSTHROUGH_INPUT_TYPES.has((el.type || '').toLowerCase())) {
      return true;
    }

    // Anything nested inside an interactive control counts as that control.
    return Boolean(
      el.closest &&
        el.closest('button, a[href], select, [role="button"], [role="combobox"], [role="listbox"], [role="option"]')
    );
  }

  function isGuarded(path) {
    return path.some((node) => node && node.nodeType === 1 && node.hasAttribute?.(GUARD_ATTRIBUTE));
  }

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' || event.isComposing || event.defaultPrevented) return;

      // composedPath sees through the Shopify Forms shadow DOM, where event.target
      // would otherwise be retargeted to the embed host.
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      if (!isGuarded(path)) return;
      if (isPassthrough(path[0])) return;

      event.preventDefault();
    },
    true
  );
})();
